import { Tool } from './tool';
import { LevelDesignerElementBase } from '../elements/element-base';
import { EventEmitter } from '@angular/core';
import { MouseEventResult } from '../managers/manager-base';

// For tools that only affect visualization (measurements, grid, etc)
export abstract class VisualTool extends Tool {
    public override isActive(): boolean {
        return this.enabled;
    }

    public toggle(): void {
        this.enabled = !this.enabled;
    }

    // Visual tools must implement render
    public abstract override render(ctx: CanvasRenderingContext2D): void;
}

// For tools that affect selected elements when clicked (lock, group, etc)
export abstract class PassiveTool extends Tool {
    public override isActive(): boolean {
        return false; // Passive tools are never "active" in the toolbar
    }

    // Optional selection change handler
    public abstract override onSelectionChanged(elements: LevelDesignerElementBase[]): void;
}

// For tools that change how element interaction works (clone, delete, etc)
export abstract class ActionTool extends Tool {
    public onActivate = new EventEmitter<void>();

    public override isActive(): boolean {
        return this.enabled;
    }

    public override activate(): void {
        this.enabled = true;
        this.onActivate.emit();
    }

    public override deactivate(): void {
        this.enabled = false;
    }

    public abstract onClick(x: number, y: number): void;

    // Action tools must implement these methods to handle interactions
    public abstract override onMouseDown(x: number, y: number): MouseEventResult | null;
    public abstract override onMouseMove(x: number, y: number): MouseEventResult | null;
    public abstract override onMouseUp(x: number, y: number): MouseEventResult | null;
    public abstract override render(ctx: CanvasRenderingContext2D): void;
} 
